<template>
  <div class="drop-area" @dragover.prevent @drop.prevent="input">
    <v-icon icon="$mdiCloudUploadOutline" size="x-large" />
    <p>
      ドラッグ & ドロップ<br />
      または
      <a href="#" @click.prevent="($refs.file as HTMLInputElement).click()"
        >ファイルを選択</a
      >
    </p>
    <!--   cancel.stopでcancelイベントの伝搬は停止-->
    <input
      ref="file"
      type="file"
      :accept="ext ? ext : undefined"
      hidden
      @change="input"
      @cancel.stop
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";

/** ファイルアップロードエリアを表示する。アップロードされたファイルはinputでemitされる */
export default defineComponent({
  name: "FileUpload",
  props: {
    /** アップロード可能なファイル拡張子, カンマ区切り可能 */
    ext: {
      type: String as PropType<string>,
      required: false,
    },
  },
  emits: ["input"],
  methods: {
    input(event: Event | DragEvent) {
      const file: File | null = ((): File | null => {
        if (event instanceof DragEvent) {
          return event.dataTransfer?.files?.[0] ?? null;
        } else {
          return (event.target as HTMLInputElement | null)?.files?.[0] ?? null;
        }
      })();
      this.$emit("input", file);

      // ファイル処理後、input要素の値をリセットして同じファイルを再選択できるようにする
      this.$nextTick(() => {
        const fileInput = this.$refs.file as HTMLInputElement;
        if (fileInput) {
          fileInput.value = "";
        }
      });
    },
  },
});
</script>

<style scoped lang="scss">
.drop-area {
  border: 1px dashed #495057;
  height: 200px;
  width: auto;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  i {
    margin: 8px;
  }

  p {
    text-align: center;
  }
}
</style>
